import React, { useEffect, useRef, useState } from 'react';
import { Upload } from 'lucide-react';
import { uploadGiveawayLogo } from '../lib/giveaway-api';

export const GiveawayLogoUpload = ({ value, admin, onChange, onBusyChange }) => {
  const input = useRef(null);
  const [preview, setPreview] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => () => { if (preview) URL.revokeObjectURL(preview); }, [preview]);
  const upload = async event => {
    const file = event.target.files?.[0];
    if (!file) return;
    setError('');
    if (file.size > 5 * 1024 * 1024) { setError('Choose a logo smaller than 5 MB.'); return; }
    setBusy(true); onBusyChange(true);
    try {
      const result = await uploadGiveawayLogo(file, admin);
      setPreview(URL.createObjectURL(file));
      onChange(result.logo_url);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); onBusyChange(false); event.target.value = ''; }
  };
  return <div className="space-y-2" data-testid="giveaway-logo-control">
    <p className="text-xs font-semibold text-navy">Logo</p>
    {(preview || value) && <div className="bg-[#111111] rounded-md p-3"><img src={preview || value} className="h-20 max-w-full object-contain mx-auto" alt="Current brand logo" data-testid="giveaway-logo-preview" /></div>}
    <input type="file" accept="image/png,image/jpeg,image/webp" ref={input} onChange={upload} className="hidden" data-testid="giveaway-logo-file" />
    <button type="button" disabled={busy} onClick={() => input.current?.click()} className="inline-flex items-center gap-2 border border-navy/30 text-navy rounded-md px-3 py-2 text-sm font-semibold disabled:opacity-50" data-testid="giveaway-logo-upload"><Upload size={16} />{busy ? 'Uploading…' : 'Upload logo'}</button>
    <p className="text-xs text-navy/60" data-testid="giveaway-logo-file-note">PNG, JPG or WebP · up to 5 MB. Save the brand to apply your logo.</p>
    {error && <p role="alert" className="text-red-700 text-sm" data-testid="giveaway-logo-upload-error">{error}</p>}
  </div>;
};